// Configuration constants shared between tree layouts

export const badgeUrls = {
	minor: '/badge_major.png',
	major: '/badge_major.png',
	capstone: '/badge_capstone.png',
	root: '/badge_major.png'
} as const;

export const badgeSizes = {
	minor: 32,
	major: 44,
	capstone: 72,
	root: 48
} as const;

export const badgeFilters = {
	ranged: 'hue-rotate(100deg) saturate(1.5) brightness(1.2)',
	melee: 'hue-rotate(0deg) saturate(1.5) brightness(1.1)',
	magic: 'hue-rotate(200deg) saturate(1.5) brightness(1.2)',
	regeneration: 'hue-rotate(70deg) saturate(1.55) brightness(1.18)',
	general: 'grayscale(1) brightness(1.3)',
	root: 'sepia(1) saturate(2) hue-rotate(10deg) brightness(1.2)',
	accuracy: 'hue-rotate(180deg) saturate(1.3) brightness(1.1)',
	defence: 'hue-rotate(140deg) saturate(1.2) brightness(1.0)',
	prayer: 'hue-rotate(260deg) saturate(1.4) brightness(1.1)'
} as const;

export const zoneOrder = ['ranged', 'magic', 'regeneration', 'melee', 'accuracy', 'defence', 'prayer'] as const;
export type Zone = typeof zoneOrder[number];

export const zoneColors: Record<string, string> = {
	ranged: '#22c55e',
	magic: '#3b82f6',
	regeneration: '#84cc16',
	melee: '#ef4444',
	accuracy: '#06b6d4',
	defence: '#14b8a6',
	prayer: '#a855f7'
};

export const badgeOutlineColors: Record<string, string> = {
	ranged: 'rgba(34, 197, 94, 0.48)',
	magic: 'rgba(79, 140, 255, 0.48)',
	regeneration: 'rgba(132, 204, 22, 0.5)',
	melee: 'rgba(239, 68, 68, 0.48)',
	accuracy: 'rgba(6, 182, 212, 0.48)',
	defence: 'rgba(20, 184, 166, 0.48)',
	prayer: 'rgba(168, 85, 247, 0.48)'
};

export const typeColors = {
	ranged: '#22c55e',
	melee: '#ef4444',
	magic: '#3b82f6',
	regeneration: '#84cc16',
	general: '#9ca3af',
	accuracy: '#06b6d4',
	defence: '#14b8a6',
	prayer: '#a855f7'
} as const;
